export const HOME = "/";
export const ADD_API = "/add";
